const REGSTRING = /[^.]+/g
// 解析字符串 a.b
export function parseString (str, data) {
  if (typeof str !== 'string') return ''
  const arr = str.match(REGSTRING)
  if (arr.length === 0 || arr.length === 1) return data[str]
  return arr.reduce((a, b) => a[b], data)
}
// 合并对象
export function assign (target, source) {
  return Object.assign(target, source)
}
// 二分查找
export  const binarySearch = (list, value, compareFunc) => {
  let start = 0
  let end = list.length - 1
  let tempIndex = null

  while (start <= end) {
    tempIndex = Math.floor((start + end) / 2)
    const midValue = list[tempIndex]
    const compareRes = compareFunc(midValue, value)
    if (compareRes === 1) {
      return tempIndex
    }

    if (compareRes === 2) {
      start = tempIndex + 1
    } else if (compareRes === 3) {
      end = tempIndex - 1
    }
  }

  return tempIndex
}